import { useEffect, useMemo, useRef, useState } from "react";
import axios, { AxiosRequestConfig } from "axios";

import Cookie from "js-cookie";

type ReturnType = {
  execute: (
    d?: { [key: string]: string | File } | FormData,
    newConfig?: AxiosRequestConfig
  ) => Promise<any>;
  cancel: () => void;
  loading: boolean;
  firstLoading: boolean;
};

const formDataMaker = (
  data: { [key: string]: string | File } | FormData
): FormData => {
  let fd: FormData;
  if (!(data instanceof FormData)) {
    fd = new FormData();
    if (typeof data !== "undefined") {
      Object.keys(data).forEach((key) => fd.append(key, data[key]));
    }
  } else {
    fd = data;
  }

  return fd;
};

const useAxios = (
  url: string,
  data?: { [key: string]: string | File } | FormData,
  configParams?: AxiosRequestConfig
): ReturnType => {
  const controller = useRef<AbortController>(new AbortController());

  const [loading, setLoading] = useState<boolean>(false);

  const [counter, setCounter] = useState(0);

  const firstLoading = useMemo(() => counter !== 0, [counter]);

  const cancel = () => {
    controller.current.abort();
    setLoading(false);
    controller.current = new AbortController();
  };

  const execute = async (
    d?: { [key: string]: string | File } | FormData,
    newConfig?: AxiosRequestConfig
  ) => {
    let fd: FormData;
    if (typeof d !== "undefined") {
      fd = formDataMaker(d);
    } else if (typeof data !== "undefined") {
      fd = formDataMaker(data);
    } else {
      fd = new FormData();
    }

    let token = Cookie.get("usertoken");
    if (typeof token !== "undefined") {
      fd.append("usertoken", token);
    } else {
      fd.append("usertoken", "undefined");
    }

    let adminpanelkey = Cookie.get("adminpanelkey");
    if (typeof adminpanelkey !== "undefined") {
      fd.append("adminpanelkey", adminpanelkey);
    }

    let cp = { ...configParams };

    if (typeof newConfig !== "undefined") {
      cp = { ...cp, ...newConfig };
    }

    setLoading(true);
    return await axios
      .request({
        url,
        data: fd,
        signal: controller.current.signal,
        baseURL: "https://sabadi.ir/api/",
        method: "POST",
        ...cp,
      })
      .then((res) => {
        setLoading(false);
        setCounter((prev) => prev + 1);
        return res.data;
      })
      .catch((err) => {
        setLoading(false);
        setCounter((prev) => prev + 1);
        return err;
      });
  };

  useEffect(() => {}, []);

  return { loading, execute, cancel, firstLoading };
};

export default useAxios;
